/**
 * Redux actions for Call Management & UX feature.
 */
import { queueService } from '../interpreter-queue/InterpreterQueueService';
import { CALL_WAITING_INCOMING, CALL_WAITING_RESPONDED, CALL_WAITING_DISMISS, INCOMING_P2P_CALL, INCOMING_P2P_CLEAR, CALL_HOLD_UPDATED, CALL_ON_HOLD, CALL_OFF_HOLD, CALL_TRANSFER_PENDING, CALL_TRANSFER_ACCEPTED, CALL_TRANSFER_CANCELLED, CONFERENCE_INVITE, CONFERENCE_ADD_RINGING, CONFERENCE_PARTICIPANT_REMOVED, CHAT_MESSAGE_RECEIVED, CHAT_MESSAGE_SENT, CHAT_HISTORY_LOADED, CHAT_PANEL_TOGGLE, PREFERENCES_UPDATED, DND_TOGGLED, DARK_MODE_CHANGED, P2P_TARGET_DND } from './actionTypes';
// ---- Call Waiting ----
export const callWaitingIncoming = (data) => ({
    type: CALL_WAITING_INCOMING,
    data
});
export const callWaitingRespond = (incomingCallId, currentCallId, action) => {
    queueService?.send({
        type: 'call_waiting_respond',
        data: { incomingCallId, currentCallId, action }
    });
    return { type: CALL_WAITING_RESPONDED, data: { incomingCallId, action } };
};
export const incomingP2PCall = (data) => ({
    type: INCOMING_P2P_CALL,
    data
});
export const clearIncomingP2PCall = () => ({
    type: INCOMING_P2P_CLEAR
});
export const callWaitingDismiss = () => ({
    type: CALL_WAITING_DISMISS
});
// ---- Call Hold ----
export const toggleCallHold = (callId, onHold) => {
    queueService?.send({
        type: 'call_hold',
        data: { callId, onHold }
    });
    return { type: CALL_HOLD_UPDATED, data: { callId, onHold } };
};
export const callOnHold = (data) => ({
    type: CALL_ON_HOLD,
    data
});
export const callOffHold = (data) => ({
    type: CALL_OFF_HOLD,
    data
});
// ---- Call Transfer ----
export const initiateCallTransfer = (callId, toPhoneNumber, toInterpreterId, transferType = 'blind', reason) => {
    queueService?.send({
        type: 'call_transfer',
        data: { callId, toPhoneNumber, toInterpreterId, transferType, reason }
    });
    return { type: CALL_TRANSFER_PENDING, data: { callId } };
};
export const acceptCallTransfer = (transferId) => {
    queueService?.send({
        type: 'call_transfer_accept',
        data: { transferId }
    });
    return { type: CALL_TRANSFER_ACCEPTED, data: { transferId } };
};
export const cancelCallTransfer = (transferId) => {
    queueService?.send({
        type: 'call_transfer_cancel',
        data: { transferId }
    });
    return { type: CALL_TRANSFER_CANCELLED, data: { transferId } };
};
// ---- Conference (3-way) ----
export const addConferenceParticipant = (callId, phoneNumber, clientId) => {
    queueService?.send({
        type: 'conference_add',
        data: { callId, phoneNumber, clientId }
    });
    return { type: CONFERENCE_ADD_RINGING, data: { callId } };
};
export const removeConferenceParticipant = (callId, participantId) => {
    queueService?.send({
        type: 'conference_remove',
        data: { callId, participantId }
    });
    return { type: CONFERENCE_PARTICIPANT_REMOVED, data: { callId, participantId } };
};
export const conferenceInvite = (data) => ({
    type: CONFERENCE_INVITE,
    data
});
// ---- In-call Chat ----
export const sendChatMessage = (callId, message) => {
    queueService?.send({
        type: 'chat_send',
        data: { callId, message }
    });
    return { type: CHAT_MESSAGE_SENT, data: { callId, message } };
};
export const requestChatHistory = (callId, limit = 100, offset = 0) => {
    queueService?.send({
        type: 'chat_history',
        data: { callId, limit, offset }
    });
    return { type: CHAT_HISTORY_LOADED, data: { callId, messages: [] } };
};
export const chatMessageReceived = (data) => ({
    type: CHAT_MESSAGE_RECEIVED,
    data
});
export const chatHistoryLoaded = (data) => ({
    type: CHAT_HISTORY_LOADED,
    data
});
export const toggleChatPanel = () => ({
    type: CHAT_PANEL_TOGGLE
});
// ---- Client Preferences ----
export const preferencesUpdated = (data) => ({
    type: PREFERENCES_UPDATED,
    data
});
export const toggleDND = (enabled, message) => {
    queueService?.send({
        type: 'preferences_update',
        data: { dnd_enabled: enabled, dnd_message: message || '' }
    });
    return { type: DND_TOGGLED, data: { enabled, message } };
};
export const setDarkMode = (mode) => {
    queueService?.send({
        type: 'preferences_update',
        data: { dark_mode: mode }
    });
    return { type: DARK_MODE_CHANGED, data: { mode } };
};
// ---- P2P Target DND ----
export const p2pTargetDnd = (data) => ({
    type: P2P_TARGET_DND,
    data
});
